import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Popconfirm, Spin, Button, message } from 'antd';
import folders from '../../Actions/folders';
import SelectsOrganization from './SelectsOrganization';
import { getCopy } from '../../helpers';
import googleDrive from '../../Actions/googleDrive';
const { getGoogleData } = googleDrive.actions;
const { saveFileName, addRemoveFileOption, getFoldersData, selectFile } = folders.actions;

class Files extends Component {
	constructor(props) {
        super(props);
        this.saveFile = this.saveFile.bind(this);
        this.saveFileIfAllowed = this.saveFileIfAllowed.bind(this);
        this.addDataFunction = this.addDataFunction.bind(this);
        this.updateDataFunction = this.updateDataFunction.bind(this);
        this.deleteDataFunction = this.deleteDataFunction.bind(this);
    }
    
    componentDidMount() {
        this.props.getFoldersData();
        this.props.getGoogleData();
    }

  	render() {  
        let { files, isLoading, filesSelected , gDriveData } = this.props;
        
    	return (			
      		<Fragment>
                <div className="download-xmls-container-text">
			        Aquí podrás definir el nombre de los archivos XML con que que quieres descargarlos, solo selecciona los campos y el orden en el que deseas que se componga el nombre de los archivos.
		        </div>
                { filesSelected && filesSelected.length > 0 &&
                     <Fragment>
                        <SelectsOrganization data={filesSelected} options={files} addDataFunction = {this.addDataFunction}  updateDataFunction = {this.updateDataFunction} deleteDataFunction={this.deleteDataFunction} id="fileDroppable" maxOptions={5} label="Nombre del archivo:" />                
                        <span className="block" style={{fontWeight: "bold"}}>Ejemplo de nombre de su archivo:</span>
                        <div className="flex-container-align-vertically bordered-label">
                            {
                                `${filesSelected.map(f => f.pathName).join('_')}.xml`
                            }
                        </div>
                    </Fragment>
                }
                <div className="confirmation-container">
                    <Popconfirm
                        title="Tiene activado Google Drive, a partir de este momento se modificará esta configuración. ¿Desea continuar?"
                        onConfirm={this.saveFile}
                        okText="Si"
                        cancelText="No"
                        disabled={gDriveData.email === ''}
                    >
                        <Button style={{marginTop: '10px'}} onClick={this.saveFileIfAllowed} type="primary">Guardar</Button>
                    </Popconfirm>
                </div>
                
                { isLoading &&
					<div className="loading-container">
						<Spin size="large" tip="Cargando" />
                    </div>    
                }        
            </Fragment>
    	);
    }  
    addDataFunction(data) {
        const { files, filesSelected } = this.props;
        let copyFilesSelected = getCopy(filesSelected);
        copyFilesSelected.push(data);
        this.props.addRemoveFileOption(files);
        this.props.selectFile(copyFilesSelected);
    }

    updateDataFunction(options, data) {            
        this.props.addRemoveFileOption(options);
        this.props.selectFile(data);    
    }

    deleteDataFunction(data) {
        const { files } = this.props;
        this.props.addRemoveFileOption(files); 
        this.props.selectFile(data.filter(x => x.selected));    
    }

    saveFileIfAllowed(){
        if (this.props.gDriveData.email === '') {
            this.saveFile();
        }
    }

    saveFile(){    
        const { filesSelected } = this.props;
        if(filesSelected && filesSelected.length !== 0) {
            let filesPath = filesSelected.filter(file => {
                return file.selected ? file.label : null;
            });
    
            let path = filesPath.map(f => f.pathName).join('/');     
            this.props.saveFileName(path);   
        } else {
            message.error('Favor de añadir por lo menos un campo', 5);
        }
        
    }
    
}


const mapStateToProps = state => {    
	return {
        files: state.folders.files,
        filesSelected: state.folders.filesSelected,
        isLoading: state._genericComponents.loading.isCurrentlyLoading,
        gDriveData: state.googleDrive.data
	};
};

const mapDispatchToProps = dispatch => {
    return {
        saveFileName:(data) => {
            dispatch(saveFileName(data))
        },
        addRemoveFileOption:(data) => {
            dispatch(addRemoveFileOption(data));
        },
        getFoldersData:() => {
            dispatch(getFoldersData());
        },
        selectFile:(data) => {
            dispatch(selectFile(data));
        },
        getGoogleData:() => {
			dispatch(getGoogleData());
		}
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(Files);
